var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('api-list',{attrs:{"type":"geofencesTrackingHistoryEvents","model":_vm.models.geofencesTrackingHistoryEvents,"quick-filters":_vm.quickFiltersSetup.geofencesTrackingHistoryEvents,"preFilters":[['model_id', 'eq', _vm.item.id]],"no-querystring":"","in-modal":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }